//Sass
require("./scss/style.scss") ;


//Custom JS
require("./js/app");
require("./js/contact-form");
require("./js/packet-order");
require("./js/tellimine");
require("./js/tellimine-tasutud");
require("./js/tellimine-tuhistatud");
